/* Synchrony offer on our pay blocks (2026-10-05).
   Synchrony's widget (app embed on product + cart pages; started here on /pages/wheel-detail)
   prices the amount in #product-content and posts its offer to this window. This file:
   1. keeps #product-content = the block's real total (set of 4 / quantity / cart total),
   2. writes Synchrony's own words into the Synchrony card ([data-rrw-syf-card]) — never our math,
   3. shows Synchrony's own line (with its "Learn how" terms) once it has content.
   Markup: <div class="rrw-syf" data-rrw-syf [data-rrw-syf-src="<total el>"] [data-rrw-syf-load]>
             <div class="rrw-syf-slot"><span class="rrw-syf-amount" hidden>$total</span></div></div> */
(function () {
  if (window.RRWSyf) return;
  var PARTNER = 'PI20280053', UNIFI = 'https://pdpone.syfpos.com/mpp/UniFi.js';
  var keep = null, wrapNow = null, cache = {}, srcEl = null, tries = 0;

  var css = document.createElement('style');
  css.textContent = '.rrw-syf{height:0;overflow:hidden}.rrw-syf.is-on{height:auto;overflow:visible;margin-top:10px;display:flow-root}'
    // Synchrony floats its cart widget right and sets 14px text inside a closed shadow root: un-float it and scale
    // the whole line to 80% so it reads as one small disclosure line under the cards.
    + '.rrw-syf #syf-unifi-widget{float:none;width:100%;margin-top:0;zoom:.8}'
    + '[data-rrw-syf-card][data-syf-none]{display:none!important}';
  document.head.appendChild(css);

  function plain(h) { return String(h || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim(); }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  // Synchrony's first enabled offer -> card figure + line, in Synchrony's own words.
  function parse(d) {
    var list = (d && d.widgetContentResponse) || [], o = null, t, m, n;
    for (var i = 0; i < list.length; i++) if (list[i] && list[i].enabled === 'true') { o = list[i]; break; }
    if (!o) return null;
    t = plain(o.content); n = t.match(/(\d+)[- ]months?/i);
    if ((m = t.match(/\$([\d,]+(?:\.\d{2})?)\/mo/i)))
      return { fig: '$' + m[1], unit: '/mo', tag: n ? (/special financing/i.test(t) ? n[1] + '-month special financing' : n[1] + ' months') : '', text: t };
    if ((m = t.match(/(\d+) interest-free payments of \$([\d,]+(?:\.\d{2})?)/i)))
      return { fig: '$' + m[2], unit: '', tag: m[1] + ' interest-free payments', text: t };
    if (/no interest if paid in full/i.test(t))
      return { fig: 'No interest', unit: '', tag: n ? 'if paid in full in ' + n[1] + ' months' : 'if paid in full', text: t };
    return null;
  }

  function amountNow() { var pc = document.getElementById('product-content'); return pc ? pc.textContent.trim() : ''; }

  function setAttr(el, k, v) { if (v == null) el.removeAttribute(k); else el.setAttribute(k, v); }

  function paint() {
    var amt = amountNow();
    if (!(amt in cache)) return;              // no answer for this total yet: leave the card as it is
    var offer = cache[amt], cards = document.querySelectorAll('[data-rrw-syf-card]');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i], f = c.querySelector('[data-rrw-syf-fig]'), g = c.querySelector('[data-rrw-syf-tag]');
      if (!f || !g) continue;
      if (!c.__syfOrig) c.__syfOrig = { f: f.innerHTML, g: g.innerHTML, a: c.getAttribute('aria-label'), t: c.getAttribute('data-pay-tagline') };
      var o = c.__syfOrig;
      if (!offer) {                            // Synchrony has no offer at this total: back to the plain card, hidden
        f.innerHTML = o.f; g.innerHTML = o.g; setAttr(c, 'aria-label', o.a); setAttr(c, 'data-pay-tagline', o.t);
        c.removeAttribute('data-syf-live'); c.setAttribute('data-syf-none', ''); continue;
      }
      c.removeAttribute('data-syf-none');
      f.textContent = offer.fig;
      if (offer.unit) { var s = document.createElement('small'); s.textContent = offer.unit; f.appendChild(s); }
      g.textContent = offer.tag;
      c.setAttribute('aria-label', 'Synchrony: ' + offer.text);
      if (o.t != null) c.setAttribute('data-pay-tagline', esc(offer.text));
      c.setAttribute('data-syf-live', '');
    }
  }

  window.addEventListener('message', function (e) {
    if (!/^https:\/\/[a-z0-9.-]+\.syfpayments\.com$/.test(e.origin)) return;
    var d = e.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (_) { return; } }
    if (!d || !d.offer) return;
    var cur = window.__syf__ && window.__syf__.currentPriceChgEventNbr;
    if (cur && d.offer.apiPriceChgEventNbr && d.offer.apiPriceChgEventNbr < cur) return;   // answer for an older total
    cache[amountNow()] = parse(d.offer);
    paint();
  });

  // Start Synchrony's widget ourselves where the app embed does not load (/pages/wheel-detail).
  function load(wrap, amt) {
    var w = document.createElement('div');
    w.id = 'syf-unifi-widget'; w.className = 'product-widget';
    w.innerHTML = '<div id="product-content" style="display:none"></div><div class="sync-price"></div>';
    w.firstChild.textContent = amt;
    wrap.appendChild(w);
    window.syfWidgetObject = { syfPartnerId: PARTNER, flowType: 'PDP', syfPlatform: 'SHOPIFY', siteCode: 'SesPdpSh01' };
    var s = document.createElement('script');
    s.id = 'syfMPPScript'; s.src = UNIFI; s.async = true;
    document.head.appendChild(s);
    return w;
  }

  // Synchrony draws its line in a closed shadow root: show the slot only once that box has height.
  function reveal(w) {
    var sp = w.querySelector('.sync-price') || w;
    var check = function () { if (wrapNow) wrapNow.classList.toggle('is-on', sp.getBoundingClientRect().height > 0); };
    if (!sp.__rrwSyf) { sp.__rrwSyf = true; if (window.ResizeObserver) new ResizeObserver(check).observe(sp); }
    check(); setTimeout(check, 1500); setTimeout(check, 5000);
  }

  function sync() {
    var wrap = document.querySelector('[data-rrw-syf]');
    if (!wrap) return false;
    wrapNow = wrap;
    var a = wrap.querySelector('.rrw-syf-amount'), src = wrap.getAttribute('data-rrw-syf-src');
    var el = src ? document.querySelector(src) : null;
    if (el && a) { var v = (el.textContent || '').trim(); if (/\d/.test(v) && a.textContent !== v) a.textContent = v; }
    if (el && el !== srcEl && window.MutationObserver) {
      srcEl = el;
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 150); }).observe(el, { childList: true, characterData: true, subtree: true });
    }
    var amt = a ? a.textContent.trim() : '';
    var w = document.getElementById('syf-unifi-widget');
    if (w) keep = w;
    else if (keep) { wrap.appendChild(keep); w = keep; }        // cart soft refresh replaced our block: move the live widget back in
    else if (wrap.hasAttribute('data-rrw-syf-load') && /\d/.test(amt) && !document.getElementById('syfMPPScript')) w = load(wrap, amt);
    if (!w) return false;
    var pc = w.querySelector('#product-content');
    if (pc && /\d/.test(amt) && pc.textContent.trim() !== amt) pc.textContent = amt;
    reveal(w); paint();
    return true;
  }

  // Pay-card figures (Acima / Snap / Synchrony) must stay inside their cards: when a figure is wider than
  // its card (Snap's "$95.11/wk*" on phones and in the cart sidebar), shrink its font just enough to fit.
  var FIG = '.rrw-cart-pay__fig, .rrw-pot__fig, .wd-paycard__fig', CARD = '.rrw-cart-pay__card, .rrw-pot__card, .wd-paycard';
  var BLOCKS = '[data-rrw-cart-pay], [data-rrw-pot], .wd-pay-mini', fitTimer;
  // One scale per pay block, so the three figures stay the same size; the small suffix ("/wk*") scales too.
  // Re-measures after each pass (rounding and fixed letter-spacing can leave a pixel over).
  function fitBlock(b) {
    var figs = b.querySelectorAll(FIG), list = [], i, s;
    for (i = 0; i < figs.length; i++) {
      var f = figs[i], sm = f.querySelectorAll('small');
      f.style.fontSize = ''; for (s = 0; s < sm.length; s++) sm[s].style.fontSize = '';
      if (f.closest(CARD) && f.offsetWidth) list.push(f);   // skip hidden figures (e.g. Snap's "Apply" fallback)
    }
    for (var pass = 0; pass < 3; pass++) {
      var k = 1;
      for (i = 0; i < list.length; i++) {
        var c = list[i].closest(CARD), cs = getComputedStyle(c);
        var avail = c.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        var r = document.createRange(); r.selectNodeContents(list[i]);
        var w = r.getBoundingClientRect().width;
        if (avail > 0 && w > avail) k = Math.min(k, avail / w * 0.98);
      }
      if (k >= 1) return;
      for (i = 0; i < list.length; i++) {
        var els = [list[i]].concat([].slice.call(list[i].querySelectorAll('small')));
        var sizes = els.map(function (el) { return Math.floor(parseFloat(getComputedStyle(el).fontSize) * k * 10) / 10 + 'px'; });
        for (s = 0; s < els.length; s++) els[s].style.fontSize = sizes[s];
      }
    }
  }
  function fitAll() { var b = document.querySelectorAll(BLOCKS); for (var i = 0; i < b.length; i++) fitBlock(b[i]); }
  function fitSoon() { clearTimeout(fitTimer); fitTimer = setTimeout(fitAll, 30); }
  function fitWatch() {
    var b = document.querySelectorAll(BLOCKS);
    for (var i = 0; i < b.length; i++) if (!b[i].__rrwFit && window.MutationObserver) {
      b[i].__rrwFit = true;
      new MutationObserver(fitSoon).observe(b[i], { childList: true, characterData: true, subtree: true });
    }
    fitAll();
  }

  // The app embed inserts its widget a little after load; look for it for up to 15s.
  function boot() { if (!sync() && ++tries < 30) setTimeout(boot, 500); }
  function start() { fitWatch(); boot(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('resize', fitSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  document.addEventListener('cart:updated', function () { setTimeout(function () { sync(); fitWatch(); }, 60); });
  document.addEventListener('rrw:cart:updated', function () { setTimeout(function () { sync(); fitWatch(); }, 60); });
  window.RRWSyf = { sync: sync, fit: fitAll };
})();
